import React, { forwardRef } from 'react';
interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    value: string;
    label: string;
  }[];
  fullWidth?: boolean;
}
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  label,
  error,
  options,
  fullWidth = true,
  className = '',
  ...props
}, ref) => {
  return <div className={`${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-106" data-mp="1cjt4663qztox">
        {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-107" data-mp="1hiw6vjw99ntq">
            {label}
          </label>}
        <select ref={ref} className={`
            block w-full rounded-md border-gray-300 shadow-sm 
            focus:border-blue-500 focus:ring-blue-500 sm:text-sm
            disabled:bg-gray-50 disabled:text-gray-500
            border p-2 bg-white
            ${error ? 'border-red-300 text-red-900 focus:border-red-500 focus:ring-red-500' : ''}
          `} {...props} data-id="element-108" data-mp="12m53kzjgnryu">
          <option value="" disabled data-id="element-109" data-mp="15t7rb3kmeu61">
            Select an option
          </option>
          {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-110" data-mp="10un01tncjktq">
              {opt.label}
            </option>)}
        </select>
        {error && <p className="mt-1 text-sm text-red-600" data-id="element-111" data-mp="1akzi9f7ov1wp">{error}</p>}
      </div>;
});
Select.displayName = 'Select';